import { useEffect, useState } from "react";
import { Button } from "./ui/button";
import { ShieldAlert, ArrowLeftCircle, Loader2, Clock } from "lucide-react";
import api, { clearAuthToken, getAuthToken } from "../lib/api";

const tokenPayload = () => {
  try {
    return JSON.parse(atob(getAuthToken().split(".")[1].replace(/-/g, "+").replace(/_/g, "/")));
  } catch { return {}; }
};

const leaveSession = (notify) => {
  clearAuthToken();
  sessionStorage.removeItem("impersonation_active");
  sessionStorage.removeItem("impersonation_target_name");
  if (notify) alert("Session d'assistance expirée. Retour à l'espace admin.");
  window.close();
  setTimeout(() => { window.location.replace("/admin"); }, 200);
};

/** Red sticky banner shown in a tab where an admin acts on behalf of another user. */
export default function ImpersonationBanner() {
  const active = typeof window !== "undefined" && sessionStorage.getItem("impersonation_active") === "1";
  const targetName = typeof window !== "undefined" ? sessionStorage.getItem("impersonation_target_name") || "" : "";
  const [exiting, setExiting] = useState(false);
  const [left, setLeft] = useState(null);
  const payload = active ? tokenPayload() : {};
  const isAssist = payload.role === "passenger";

  useEffect(() => {
    if (!active) return;
    const exp = (tokenPayload().exp || 0) * 1000;
    const tick = () => {
      const remaining = Math.max(0, exp - Date.now());
      setLeft(remaining);
      if (remaining === 0) { clearInterval(id); leaveSession(true); }
    };
    const id = setInterval(tick, 1000);
    tick();
    return () => clearInterval(id);
  }, [active]);

  if (!active) return null;

  const handleExit = async () => {
    setExiting(true);
    try { await api.post("/auth/impersonation/end"); } catch { /* token may be expired */ }
    leaveSession(false);
  };

  const ms = left || 0;
  const mm = String(Math.floor(ms / 60000)).padStart(2, "0");
  const ss = String(Math.floor((ms % 60000) / 1000)).padStart(2, "0");

  return (
    <div className="sticky top-0 z-[1000] bg-[#DC2626] text-white shadow-md" data-testid="impersonation-banner">
      <div className="max-w-7xl mx-auto px-3 py-2 flex items-center justify-between gap-2 text-xs sm:text-sm">
        <div className="flex items-center gap-2 min-w-0">
          <ShieldAlert className="w-4 h-4 shrink-0" />
          <p className="font-semibold truncate">
            {isAssist ? "Mode assistance" : "Mode support admin"} · Vous agissez en tant que <strong>{targetName || "utilisateur"}</strong>
            {isAssist && <span className="hidden sm:inline font-normal opacity-90"> · Paiement en espèces uniquement</span>}
          </p>
          <span className="inline-flex items-center gap-1 bg-white/15 rounded-full px-2 py-0.5 font-mono text-[11px] shrink-0" data-testid="impersonation-countdown">
            <Clock className="w-3 h-3" />{mm}:{ss}
          </span>
        </div>
        <Button size="sm" onClick={handleExit} disabled={exiting} className="bg-white hover:bg-white/90 text-[#DC2626] h-7 px-3 text-xs shrink-0 font-semibold" data-testid="exit-impersonation-btn">
          {exiting ? <Loader2 className="w-3.5 h-3.5 animate-spin mr-1" /> : <ArrowLeftCircle className="w-3.5 h-3.5 mr-1" />} Revenir à l'admin
        </Button>
      </div>
    </div>
  );
}
